import { NavLink } from 'react-router-dom';
import './Services.css';

const SERVICES = [
  { name: 'Wedding',       sub: 'Photography',  path: '/wedding' },
  { name: 'Pre-Wedding',   sub: 'Shoot',         path: '/pre-wedding' },
  { name: 'Baby',          sub: 'Photography',   path: '/baby' },
  { name: 'Maternity',     sub: 'Shoot',         path: '/maternity' },
  { name: 'Bharatanatyam',        sub: 'Portraits',     path: '/bharatanatyam' },
  { name: 'Corporate',     sub: 'Events',        path: '/corporate' },
];

export default function ServiceStrip() {
  return (
    <section className="sstrip-section">
      <p className="sstrip-label">Our Services</p>
      <div className="sstrip-grid">
        {SERVICES.map((s) => (
          <NavLink
            key={s.name}
            to={s.path}
            className="sstrip-item"
            style={{ textDecoration: 'none' }}
          >
            <span className="sstrip-name">{s.name}</span>
            <span className="sstrip-sub">{s.sub}</span>
          </NavLink>
        ))}
      </div>
    </section>
  );
}